const locale = {
    home: 'Home',
    services: 'Services',
    support: 'Support',
    memberSpace: 'Member Space',
    baseService: 'Base Services',
    lineSegmentDetector: 'Line Segment Detector',
    arcLineDetector: 'ArcLine Detector',
    contrastEnhancement: 'Contrast Enhancement',
    denoising: 'Denoising',
    deblurring: 'Deblurring',
    deraining: 'Deraining',
    resolutionEnhancement: 'Resolution Enhancement',
    inpainting: 'Inpainting',
    detection: 'Detection',
    objectDetection: 'Object Detection',
    poseEstimation: 'Pose Estimation',
    faceDetection: 'Face Detection',
    counting: 'Counting',
    countObjects: 'Count Objects',
    authentication: 'Authentication',
    advanced: 'Advanced services',
    correctiveExercise: 'Corrective exercise',
    learning: 'Learning',
    deepLearning: 'Deep Learning',
    ticket: 'Ticket',
    newTicket: 'New Ticket',
    tickets: 'My Tickets',
    faq: 'FAQ',
    dlJobs: 'DL Jobs',
    customerDlJobs: 'My DL Jobs',
    profile: 'Profile',
    pricing: 'Pricing',
    paymentArchive: 'Payment Archive',
    serviceRequests: 'My Service Requests',
    annotationService: 'Annotation',
    classificationAnnotation: 'Classification Annotation',
    boundaryAnnotation: 'Boundary Annotation',
    boundingBoxAnnotation: 'Bounding Box Annotation',
    faceRecognition: 'Face Recognition',
    annotationList: 'My Annotations',
    anomalyDetection: 'Anomaly Detection',
    permissionService: 'Permission Service'
};

export default locale;
